import React from "react";
import { Check } from "lucide-react";

const points = [
  "Separate location records",
  "Regional settings per location",
  "Location-specific staff",
  "Central oversight",
  "Cross-location reports",
  "Open issue monitoring",
  "Temperature exception tracking",
  "Inspection history",
];

export default function MultiLocationSection() {
  return (
    <section id="multi-location" className="relative">
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
        <h2 className="heading-app text-3xl md:text-4xl mb-4">
          Manage Every Location From One Dashboard
        </h2>
        <p className="text-white/75 max-w-3xl">
          Each location can complete its own checks through the mobile app while management monitors
          activity, incidents, overdue work and compliance records from the central Crystal HACCP
          dashboard.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-8">
          {points.map((point) => (
            <div key={point} className="app-card p-4 flex items-start gap-2">
              <Check size={16} className="text-crystal-orange mt-0.5 shrink-0" />
              <span className="text-white/80 text-sm">{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
